import { MoreVert } from "@mui/icons-material";
import { IconButton, ListItem, Tooltip } from "@mui/material";

import Svg from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";
import { useActionItemRow } from "../hooks/useActionItemRow";
import { STRINGS } from "../utils/strings";

import ActionItemRowMenu from "./ActionItemRowMenu";

const RESULT_CLASSES = "text-sm sm:p-2 px-2 py-2 self-center";

export default function ActionItemRow({
  actionItem,
  onEdit,
  onDelete,
  onView,
  onNavigateToClient,
  showClientColumn,
  showTypeColumn,
}) {
  const {
    anchorEl,
    menuOpen,
    name,
    actionText,
    onCase,
    actionTypeLabel,
    status,
    handleMenuOpen,
    handleMenuClose,
    handleEdit,
    handleDelete,
    handleView,
    handleNavigateClick,
    truncate,
    getClientName,
    getCreatedByName,
    getDueDate,
  } = useActionItemRow({ actionItem, onEdit, onDelete, onView, onNavigateToClient });
  const actionId = actionItem?.pk ?? actionItem?.id ?? "";

  return (
    <ListItem className="border-b border-gray-200 px-0 hover:bg-gray-50">
      <div className="flex w-full items-center">
        {showClientColumn && (
          <div className={`${RESULT_CLASSES} w-1/6`}>
            {onCase?.client?.id ? (
              <div className="flex items-center justify-between">
                <Tooltip title={getClientName()}>
                  <span
                    id={`actionable-items-client-name-${actionId}`}
                    className="cursor-pointer hover:underline"
                    onClick={handleNavigateClick}
                  >
                    {truncate(getClientName(), 20)}
                  </span>
                </Tooltip>
                <span
                  id={`actionable-items-client-icon-${actionId}`}
                  className="cursor-pointer pr-12"
                  onClick={handleNavigateClick}
                >
                  <Svg name="his-file-search" color={HNSColors.primary[500]} />
                </span>
              </div>
            ) : (
              <Tooltip title={getClientName()}>
                <span>{truncate(getClientName(), 20)}</span>
              </Tooltip>
            )}
          </div>
        )}

        {showTypeColumn && (
          <div className={`${RESULT_CLASSES} hidden w-1/6 md:block`}>
            <Tooltip title={actionTypeLabel || STRINGS.DEFAULT_VALUE}>
              <span>{truncate(actionTypeLabel || STRINGS.DEFAULT_VALUE, 20)}</span>
            </Tooltip>
          </div>
        )}

        <div
          className={`${RESULT_CLASSES} ${showClientColumn || showTypeColumn ? "w-1/6" : "w-1/4"} hidden md:block`}
        >
          <Tooltip title={name}>
            <span>{truncate(name, 20)}</span>
          </Tooltip>
        </div>

        <div
          className={`${RESULT_CLASSES} ${showClientColumn || showTypeColumn ? "w-1/6" : "w-1/4"} hidden md:block`}
        >
          <Tooltip title={getCreatedByName()}>
            <span>{truncate(getCreatedByName(), 20)}</span>
          </Tooltip>
        </div>

        <div
          className={`${RESULT_CLASSES} ${showClientColumn || showTypeColumn ? "w-1/6" : "w-[30%]"} block`}
        >
          <Tooltip title={actionText}>
            <span>{truncate(actionText, 30)}</span>
          </Tooltip>
        </div>

        <div
          className={`${RESULT_CLASSES} ${showClientColumn || showTypeColumn ? "w-1/6" : "w-[20%]"} hidden md:block`}
        >
          {getDueDate()}
        </div>

        <div className={`${RESULT_CLASSES} flex w-[10%] items-center justify-center gap-2`}>
          <IconButton
            id={`actionable-items-row-menu-button-${actionId}`}
            size="small"
            onClick={handleMenuOpen}
          >
            <MoreVert sx={{ color: HNSColors.primary[500], fontSize: 24 }} />
          </IconButton>

          <ActionItemRowMenu
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleMenuClose}
            onView={handleView}
            onEdit={handleEdit}
            onDelete={handleDelete}
            status={status}
            actionId={actionId}
          />
        </div>
      </div>
    </ListItem>
  );
}
